import React, { Component } from 'react';
import styled from 'styled-components';
import { Tap } from '../dooh-react-utils';
import preloader from '../preload';
import hand from '../assets/start.png';

const Wrap = styled.div`
  background: url('${() =>
    preloader.get(require('../assets/cta.jpg'))}') no-repeat 0 0;
  padding-top: 800px;
  color: white;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 1080px;
    height: 1920px;
  }

  .loop {
    position: absolute;
    top: 0;
    left: 0;
    width: 1080px;
    height: 200px;
  }

  .main {
    position: absolute;
    width: 1080px;
    height: 1720px;
    top: 200px;
    left: 0;
  }

  img {
    display: block;
    margin: 0 auto;
    position: relative;
    top: 150px;

    @keyframes pulse_animation {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
      }
    }

    animation-name: pulse_animation;
    animation-duration: 1200ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

class Screen extends Component {
  render() {
    let loop = this.props.loop;

    return (
      <Wrap>
        <img src={preloader.get(hand)} alt="tap" />
        {loop && (
          <video
            src={preloader.get(require('../assets/loop.mp4'))}
            loop
            autoPlay
            muted
          />
        )}
        <Tap
          className="loop"
          preventDoubleTap={false}
          onTap={() => this.props.update(s => ({ loop: !s.loop }))}
        />
        <Tap
          className="main"
          preventDoubleTap={false}
          onTap={() => !loop && this.props.gotoNextScreen()}
        />
      </Wrap>
    );
  }
}

export default Screen;
